const _ = require('lodash');

const modalElementId = 'uc-corner-modal';

import { SettingsService } from '../../../services/settings-service';
import SecondaryAdvancePrivacyViewController from '../privacy-views/secondary-advance-privacy-view/secondary-advance-privacy-view-controller';
import { ConsentsStatusService } from '../../../services/consents-services/consents-status.service';
import { DataService } from '../../../services/utilities/data.service';
import DataExchangeService from '../../../services/data-exchange.service';
import { UtilityService } from '../../../services/utility.service';

export default class PrivacyCornerModalViewController {
    secondaryAdvancePrivacyViewController: SecondaryAdvancePrivacyViewController;
    private updateView: any;
    private settingsService: SettingsService;
    private utilityService: UtilityService;

    constructor(mainViewContoller, updateView, bannerController, utilityService) {
        this.updateView = updateView;
        this.utilityService = utilityService;

        this.settingsService = utilityService.settingsService;
        const layoutParams = this.getPreparedLayoutParams();

        this.setInitialState();
        this.secondaryAdvancePrivacyViewController = new SecondaryAdvancePrivacyViewController(
            mainViewContoller,
            this,
            layoutParams,
            bannerController,
            utilityService
        );
    }

    private setInitialState() {
        if (this.secondaryAdvancePrivacyViewController) {
            this.secondaryAdvancePrivacyViewController.resetPurposes();
        }
    }

    private openModal() {
        this.visible = true;
        this.resetAll();
    }

    private closeModal() {
        this.visible = false;
        this.resetAll();

        const dataExchangeService = new DataExchangeService();
        dataExchangeService.dataExchangeArray = this.settingsService.settings.dataExchangeOnPage;
        dataExchangeService.dispatchEvent('uc_privacySettingsSideClosed', {event: 'uc_privacySettingsSideClosed'});

        this.utilityService.optinTeimeoutService.stopTimer();
        ConsentsStatusService.resetAllConsents(DataService.consents);
    }

    private resetAll() {
        this.resetViews();
        this.setInitialState();
        this.updateView();
    }

    private resetViews() {
        this.secondaryAdvancePrivacyViewController.visible = false;
    }

    private getHtml() {
        this.utilityService.developmentLog('getting corner modal HTML');
        let viewHTML: any = 'No appropriate template or some error';
        this.resetViews();
        this.utilityService.developmentLog('corner modal visibility reset');
        this.secondaryAdvancePrivacyViewController.visible = true;
        viewHTML = this.secondaryAdvancePrivacyViewController.htmlString;
        this.utilityService.developmentLog('got corner modal HTML');
        return viewHTML;
    }

    private getPreparedLayoutParams() {
        const layouts = SettingsService.layouts;
        const goalLayout = _.find(layouts, {
            name: this.settingsService.settings.layout
        });

        if (typeof goalLayout === 'undefined') {
            throw new Error('goalLayout not found: ' + this.settingsService.settings.layout);
        }

        return {
            modalView: goalLayout.cornerModalView,
            initialModalView: goalLayout.initialCornerModalView
        };
    }

    public getModalWrapperElement() {
        return document.getElementById(modalElementId);
    }

    public initHandling() {
        if (this.visible) {
            this.secondaryAdvancePrivacyViewController.initHandling();
        }
    }

    public set visible(_isVisible: boolean) {
        this.settingsService.cornerModelIsVisible = _isVisible;
    }

    public get visible() {
        return this.settingsService.elementsVisibility.cornerModel;
    }

    public get htmlString(): string {
        if (this.visible) {
            return this.getHtml();
        }
        return '';
    }
}
